@if (copyType() === 'TO') {
  <nz-modal [nzVisible]="true" nzWidth="500px" nzTitle="Copy to"
            (nzOnCancel)="onCancel()" (nzOnOk)="onOk()">
    <ng-container *nzModalContent>
      <form nz-form se-container="1" labelWidth="250px" nzLayout="vertical" #form="ngForm">
        <se label="Type">
          <nz-select [(ngModel)]="data.type" [ngModelOptions]="{standalone: true}"
                     [nzOptions]="filteredTransactionTypeOptions()"
                     nzAllowClear
                     name="Type" nzSize="default" nzPlaceHolder="Select transaction type">
          </nz-select>
        </se>
      </form>
    </ng-container>
  </nz-modal>
}

@if (copyType() === 'FROM') {
  <nz-modal [nzVisible]="true" nzWidth="1000px" nzTitle="Copy from"
            (nzOnCancel)="onCancel()" (nzOnOk)="onOk()">
    <ng-container *nzModalContent>
      <form style="margin-bottom: 15px" nz-form se-container="1" labelWidth="250px" nzLayout="vertical" #form="ngForm">
        <se label="Type" col="2">
          <nz-select [(ngModel)]="data.type"
                     [ngModelOptions]="{standalone: true}" [nzOptions]="filteredTransactionTypeOptions()"
                     nzAllowClear
                     name="Type" nzSize="default" nzPlaceHolder="Select transaction type">
          </nz-select>
        </se>

        <se label="Date Range" col="2">
          <app-date-range [(from)]="data.start" [(to)]="data.end" [allowClear]="false"></app-date-range>
          <button type="button" style="margin-left: 10px" nz-button nzType="primary" (click)="onSearch()" [disabled]="!data.type || !data.start || !data.end">
            Search
          </button>
        </se>
      </form>


      <nz-table [nzLoading]="loading()" #t [nzData]="transactions()" [nzFrontPagination]="false" [nzShowPagination]="false"
                nzBordered="true"
                nzSize="small" [nzScroll]="{ x: '800px', y: '400px' }">
        <thead>
        <tr>
          <th nzWidth="40px" [nzAlign]="'center'">

          </th>
          <ng-container *ngFor="let col of columns; let index = index; let last = last">
            <th [nzWidth]="$any(col)?.width" nz-resizable nzPreview (nzResizeEnd)="col.width = $event.width + 'px'"
                [nzAlign]="$any(col).align ?? 'left'">
              <nz-resize-handle *ngIf="!last" nzDirection="right">
                <i></i>
              </nz-resize-handle>
              {{ col.title }}
            </th>
          </ng-container>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of t.data">
          <td>
            <nz-switch
              [ngModel]="isTransactionSelected(item)"
              [nzControl]="true"
              (click)="onToggleCopy(item)"
              [nzCheckedChildren]="''"
              [nzUnCheckedChildren]="''">
            </nz-switch>
          </td>
          <td>
            {{ item?.docDate | customDate }}
          </td>
          <td>
            {{ item?.docCode }}
          </td>
          <td>
            {{ item?.customerName }}
          </td>
          <td class="text-right">
            {{ item?.netTotalAmountLocal | price }}
          </td>
        </tr>
        </tbody>
      </nz-table>
    </ng-container>
  </nz-modal>
}
